// extracted by mini-css-extract-plugin
export var leftAlign = "_1z-2";
export var popper = "_1z-0";
export var subtitle = "_1z-1";